var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/landing_page/index.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { fetchAccount } from 'soapbox/actions/accounts';
import { prepareRequest } from 'soapbox/actions/consumer-auth';
import Account from 'soapbox/components/account';
import { Button, Card, CardBody, Stack, Text } from 'soapbox/components/ui';
import VerificationBadge from 'soapbox/components/verification_badge';
import RegistrationForm from 'soapbox/features/auth_login/components/registration_form';
import { useAppDispatch, useAppSelector, useFeatures, useSoapboxConfig } from 'soapbox/hooks';
import { capitalize } from 'soapbox/utils/strings';
const LandingPage = () => {
  const dispatch = useAppDispatch();
  const features = useFeatures();
  const soapboxConfig = useSoapboxConfig();
  const pepeEnabled = soapboxConfig.getIn(['extensions', 'pepe', 'enabled']) === true;
  const instance = useAppSelector(state => state.instance);
  const accounts = useAppSelector(state => state.accounts);
  const pepeOpen = useAppSelector(state => state.verification.instance.get('registrations') === true);
  React.useEffect(() => {
    const staff = instance.pleroma.getIn(['metadata', 'staff_accounts']).map(s => s.split('/').pop());
    staff.forEach(s => dispatch(fetchAccount(s)));
  }, [instance, dispatch]);
  const staffAccounts = React.useMemo(() => {
    // eslint-disable-next-line eqeqeq
    if (accounts == null) return [];
    const a = Object.values(accounts?.toJSON()).filter(a => a.admin || a.moderator);
    return a;
  }, [accounts]);
  const userCount = instance.stats.get('user_count');
  const homeDescription = React.useMemo(() => {
    const format = new Intl.NumberFormat().format(userCount);
    return soapboxConfig.homeDescription.replace('[users]', format);
  }, [userCount, soapboxConfig]);

  /** Registrations are closed */
  const renderClosed = () => {
    return /*#__PURE__*/React.createElement(Stack, {
      space: 3,
      "data-testid": "registrations-closed",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Text, {
      size: "xl",
      weight: "bold",
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registration.closed_title",
      defaultMessage: "Registrations Closed",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48,
        columnNumber: 11
      }
    })), /*#__PURE__*/React.createElement(Text, {
      theme: "muted",
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registration.closed_message",
      defaultMessage: "{instance} is not accepting new members.",
      values: {
        instance: instance.title
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 54,
        columnNumber: 11
      }
    })));
  };

  /** Custom Registrations */
  const renderCustom = () => {
    const {
      customRegProvider
    } = soapboxConfig;
    const {
      customRegUrl
    } = soapboxConfig;
    const onClickUrl = () => {
      window.open(customRegUrl);
    };
    return /*#__PURE__*/React.createElement(Stack, {
      space: 3,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 73,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Stack, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 74,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Text, {
      size: "2xl",
      weight: "bold",
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registrations.redirect",
      defaultMessage: "No account yet?",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 13
      }
    }))), /*#__PURE__*/React.createElement(Button, {
      onClick: onClickUrl,
      theme: "primary",
      block: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 80,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registration.custom_provider_tooltip",
      defaultMessage: "Sign up with {provider}",
      values: {
        provider: capitalize(customRegProvider)
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 81,
        columnNumber: 11
      }
    })));
  };

  /** Mastodon API registrations are open */
  const renderOpen = () => {
    return /*#__PURE__*/React.createElement(RegistrationForm, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 93,
        columnNumber: 12
      }
    });
  };

  /** Display login button for external provider. */
  const renderProvider = () => {
    const {
      authProvider
    } = soapboxConfig;
    return /*#__PURE__*/React.createElement(Stack, {
      space: 3,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 101,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Stack, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 102,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Text, {
      size: "2xl",
      weight: "bold",
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 103,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registrations.get_started",
      defaultMessage: "Let's get started!",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 104,
        columnNumber: 13
      }
    }))), /*#__PURE__*/React.createElement(Button, {
      onClick: () => dispatch(prepareRequest(authProvider)),
      theme: "primary",
      block: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 108,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "oauth_consumer.tooltip",
      defaultMessage: "Sign in with {provider}",
      values: {
        provider: capitalize(authProvider)
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 109,
        columnNumber: 11
      }
    })));
  };

  /** Pepe API registrations are open */
  const renderPepe = () => {
    return /*#__PURE__*/React.createElement(Stack, {
      space: 3,
      "data-testid": "registrations-pepe",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 122,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(VerificationBadge, {
      className: "h-16 w-16 mx-auto",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 123,
        columnNumber: 9
      }
    }), /*#__PURE__*/React.createElement(Stack, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 125,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Text, {
      size: "2xl",
      weight: "bold",
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 126,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registrations.get_started",
      defaultMessage: "Let's get started!",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 127,
        columnNumber: 13
      }
    })), /*#__PURE__*/React.createElement(Text, {
      theme: "muted",
      align: "center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 129,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registrations.tagline",
      defaultMessage: "Social Media Without Discrimination",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 130,
        columnNumber: 13
      }
    }))), /*#__PURE__*/React.createElement(Button, {
      to: "/verify",
      theme: "primary",
      block: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 134,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "registrations.create_account",
      defaultMessage: "Create an account",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 135,
        columnNumber: 11
      }
    })));
  };

  // Render registration flow depending on features
  const renderBody = () => {
    if (soapboxConfig.authProvider) {
      return renderProvider();
    } else if (pepeEnabled && pepeOpen) {
      return renderPepe();
    } else if (features.accountCreation && instance.registrations) {
      return renderOpen();
    } else if (soapboxConfig.customRegProvider) {
      return renderCustom();
    } else {
      return renderClosed();
    }
  };
  return /*#__PURE__*/React.createElement("main", {
    className: "mt-16 sm:mt-24",
    "data-testid": "homepage",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 157,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-auto max-w-7xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 158,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 lg:grid-cols-12 gap-8 py-12",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 160,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 161,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    space: 5,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 162,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-5xl font-extrabold text-transparent text-ellipsis overflow-hidden bg-clip-text bg-gradient-to-br from-accent-500 via-primary-500 to-gradient-end sm:mt-5 sm:leading-none lg:mt-6 lg:text-6xl xl:text-7xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 163,
      columnNumber: 17
    }
  }, instance.title), /*#__PURE__*/React.createElement(Text, {
    size: "lg",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 166,
      columnNumber: 17
    }
  }, homeDescription ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: homeDescription
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 168,
      columnNumber: 39
    }
  }) : instance.description), /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 171,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 172,
      columnNumber: 19
    }
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-xl text-gray-800 dark:text-gray-300",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 173,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "landingPage.admins",
    defaultMessage: "Moderators",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 174,
      columnNumber: 23
    }
  }))), /*#__PURE__*/React.createElement("a", {
    href: `mailto:${instance.email}`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 177,
      columnNumber: 19
    }
  }, instance.email), /*#__PURE__*/React.createElement(Stack, {
    space: 3,
    className: "mt-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 180,
      columnNumber: 19
    }
  }, staffAccounts.map(s => /*#__PURE__*/React.createElement(Account, {
    key: s.id,
    hideActions: true,
    account: s,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 182,
      columnNumber: 48
    }
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "sm:mt-24 lg:mt-0 lg:col-span-6 self-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 189,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Card, {
    size: "xl",
    variant: "rounded",
    className: "sm:max-w-md sm:w-full sm:mx-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 190,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(CardBody, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 191,
      columnNumber: 15
    }
  }, renderBody()))))));
};
export default LandingPage;